import { useContext } from 'react'

import { CalendarHeaderActionsContainerContext } from '../../Calendar.contexts'

export function useCalendarHeaderActionsContainerContext() {
  return useContext(CalendarHeaderActionsContainerContext)
}
